<div class="modal-header">
    <h5 class="modal-title">Afbeelding bewerken</h5>
    <div>
        <a (click)="close()" title="Annuleren" class="btn btn-transparent mr-2">Annuleren</a>
        <a (click)="upload()" title="Opslaan" class="btn btn-success">Opslaan</a>
    </div>
</div>
<div class="modal-body p-5">
    <image-cropper style="width: 80vw; height: 80vh;" [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true" [resizeToHeight]="1600" [imageQuality]="90" [aspectRatio]="16 / 9"
        format="jpeg" (imageCropped)="imageCropped($event)" (cropperReady)="cropperReady()"
        (loadImageFailed)="loadImageFailed()"></image-cropper>
</div>